// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"styles_modalContainer__Hf_mF","inputArea":"styles_inputArea__AGnsD","btn":"styles_btn__se_As"};